import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const FeaturedProject = () => {
  const { featuredProject, sections } = portfolioData;

  if (!featuredProject) return null;

  return (
    <section id="featured-project" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.featuredProjectTitle}</h2>
        <motion.article
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.35 }}
          className="mt-8 rounded-2xl border border-indigo-200 bg-gradient-to-r from-indigo-50 to-sky-50 p-7 shadow-lg shadow-indigo-100/50"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-700">
            Featured
          </p>
          <h3 className="mt-2 text-2xl font-bold text-slate-900">{featuredProject.name}</h3>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-700">
            {featuredProject.summary}
          </p>
          <p className="mt-3 text-sm text-slate-700">
            <span className="font-semibold">Dataset:</span> {featuredProject.dataset}
          </p>
          <p className="mt-2 text-sm text-slate-700">
            <span className="font-semibold">Tools:</span> {featuredProject.tools.join(" | ")}
          </p>
          <div className="mt-4 flex gap-4">
            {featuredProject.links?.code && (
              <a
                href={featuredProject.links.code}
                target="_blank"
                rel="noreferrer"
                className="text-sm font-semibold text-indigo-700 hover:text-indigo-600"
              >
                GitHub
              </a>
            )}
            {featuredProject.links?.notebook && (
              <a
                href={featuredProject.links.notebook}
                target="_blank"
                rel="noreferrer"
                className="text-sm font-semibold text-indigo-700 hover:text-indigo-600"
              >
                Notebook
              </a>
            )}
          </div>
        </motion.article>
      </div>
    </section>
  );
};

export default FeaturedProject;
